<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    dark
    floating
    persistent
    mobile-break-point="991"
    width="260"
  >
    <v-img :src="image" height="100%">
      <v-layout class="fill-height" tag="v-list" column>
        <v-list-tile class="py-3">
          <v-list-tile-title class="px-3">
            <span class="display-1">
              {{ appName }}
              <span style="font-size:11px" class="font-italic">
                V
                <span style="font-size:8px" class="font-italic">01.20</span>
              </span>
            </span>
          </v-list-tile-title>
        </v-list-tile>
        <v-divider />
        <v-list-tile
          v-for="(link, i) in links"
          :key="i"
          :to="link.to"
          :active-class="color"
          avatar
          class="v-list-item"
        >
          <v-list-tile-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title v-text="link.text" />
        </v-list-tile>
        <v-list-tile
          target="_blank"
          href="http://hris.indomaretgroup.com"
          disabled
          active-class="primary"
          class="v-list-item v-list__tile--buy"
        >
          <v-list-tile-action>
            <v-icon>mdi-alert-box</v-icon>
          </v-list-tile-action>
          <v-list-tile-title class="font-weight-light">Career Indomaret Group</v-list-tile-title>
        </v-list-tile>
      </v-layout>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapMutations, mapState } from "vuex";

export default {
  name: "CoreDrawer",

  data: () => ({
    logo: "dtlogo.png",
    links: [
      {
        to: "/dashboard",
        icon: "mdi-view-dashboard",
        text: "Dashboard"
      },
      {
        to: "/pelamar",
        icon: "mdi-account-card-details",
        text: "Pelamar"
      },
      {
        to: "/hasil-test",
        icon: "mdi-clipboard-outline",
        text: "Hasil Test"
      },
      {
        to: "/ubah-password",
        icon: "mdi-lock",
        text: "Ubah Password"
      },
      {
        to: "/ubah-akses-tes",
        icon: "phonelink_lock",
        text: "Ubah Akses Tes"
      }
    ],
    responsive: false
  }),
  computed: {
    ...mapState("app", ["image", "color"]),
    inputValue: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      }
    },
    items() {
      return this.$t("Layout.View.items");
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  }
};
</script>

<style lang="scss">
#app-drawer {
  .v-list__tile {
    border-radius: 4px;

    &--buy {
      margin-top: auto;
      margin-bottom: 17px;
    }
  }

  .v-image__image--contain {
    top: 9px;
    height: 60%;
  }

  .search-input {
    margin-bottom: 30px !important;
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>
